import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import StarFilled from "../assets/ratingFilled.svg";
import StarEmpty from "../assets/ratingEmpty.svg";
import { useSelector } from "react-redux";

export default function Ratings(props) {
  const { value, label } = props;
  const [filledStars, setFilledStars] = useState([]);
  const [unfilledStars, setUnfilledStars] = useState([]);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);

  const Star = (fill) => {
    return fill ? (
      <img
        src={StarFilled}
        style={{
          width: isDesktopOrLaptop
            ? props.fontSize
              ? "15px"
              : "17px"
            : "18px",
          height: isDesktopOrLaptop
            ? props.fontSize
              ? "15px"
              : "16px"
            : "17px",
          margin: "0 11px 0px 0px",
        }}
      />
    ) : (
      <img
        src={StarEmpty}
        style={{
          width: isDesktopOrLaptop
            ? props.fontSize
              ? "15px"
              : "17px"
            : "18px",
          height: isDesktopOrLaptop
            ? props.fontSize
              ? "15px"
              : "16px"
            : "17px",
          margin: "0 11px 0px 0px",
        }}
      />
    );
  };

  useEffect(() => {
    var i = 0;
    const list1 = [];
    const list2 = [];
    if (value === -1) {
      i = 6;
    }

    for (i = 0; i < value; i++) {
      list1.push(i);
    }

    if (value === -1) {
      i = 6;
    }

    for (i; i < 6; i++) {
      list2.push(i);
    }
    setFilledStars(list1);
    setUnfilledStars(list2);
  }, [value]);

  const fillStars = () => {
    return filledStars.map(() => {
      return Star(true);
    });
  };
  const unfillStars = () => {
    return unfilledStars.map(() => {
      return Star(false);
    });
  };

  return value >= 0 ? (
    <Grid
      style={{
        height: "17px",
        display: "flex",
        alignItems: "center",
        marginTop: props.marginTop ? props.marginTop : "20px",
      }}
    >
      <Grid
        item
        xs={props.fontSize ? "auto" : isDesktopOrLaptop ? "auto" : "auto"}
      >
        <p
          style={{
            fontFamily: "Overpass",
            fontSize: props.fontSize ? props.fontSize : "12px",
            fontWeight: 600,
            fontStretch: "normal",
            fontStyle: "normal",
            // lineHeight: 1.5,
            paddingTop: "2px",
            letterSpacing: "normal",
            color: "#808080",
            margin: "0 0px 0 0",
            width: props.fontSize ? "90px" : "136px",
          }}
        >
          {label} <span style={{ color: "#0040ff" }}>({value})</span>
        </p>
      </Grid>
      <Grid
        item
        xs={props.fontSize ? 8 : isDesktopOrLaptop ? "auto" : 7}
        style={{
          display: "flex",
          justifyContent: isDesktopOrLaptop ? "flex-start" : "flex-end",
        }}
      >
        {fillStars()}
        {unfillStars()}
      </Grid>
    </Grid>
  ) : null;
}
